<template>
  <div class="p-6 max-w-4xl mx-auto font-sans bg-gray-50 min-h-screen">
    <div class="bg-white p-8 rounded-xl shadow-sm">
      <h1 class="text-3xl font-bold text-center mb-10 text-gray-900">{{ $t('history.our_history') }}</h1>
      <div class="relative pl-8 border-l-2 border-gray-200 space-y-12 ml-4">
        <div v-for="(year, i) in years" :key="i" class="relative">
          <!-- Dot -->
          <div 
            class="absolute -left-[11px] top-1 w-5 h-5 rounded-full bg-white border-4 transition-colors duration-300"
            :class="getColors(year.color).border"
          ></div>
          
          <div class="mb-6 pl-4">
            <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-4">
              <h2 class="text-2xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-gray-800 to-gray-600">{{ year.title }}</h2>
              <span class="text-lg font-bold px-3 py-1 rounded-full bg-gray-100" :class="getColors(year.color).text">{{ year.year }}</span>
            </div>
            
            <div class="overflow-hidden rounded-xl shadow-md mb-5 hover:shadow-lg transition-shadow duration-300" v-if="year.img">
              <img 
                  :src="image(year.img, { height: 350, format: 'webp' })"
                  class="w-full h-auto max-h-[400px] object-cover hover:scale-105 transition-transform duration-500"
                  alt=""
              />
            </div>

            <div class="text-gray-600 leading-7 text-lg">
              {{ year.desc }}
            </div>
          </div>
          <div v-if="i < years.length - 1" class="border-b border-gray-100 my-8 w-full"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup >
import { useI18n } from 'vue-i18n';
const route = useRoute();
const ogUrl = computed(() => `https://cld.eu${route.fullPath}`);
const { t } = useI18n();
const image = useImage();

const years = ref([

  {
    color: 'violet', year: "2026",
    title: t('history.eu_expansion'),
    desc: t('history.eu_expansion_desc')
  },
  {
    color: 'green', year: "2025",
    title: t('history.dropshipping'),
    desc: t('history.dropshipping_desc')
  },
  {
    color: 'blue', year: "2021 - 2023",
    title: t('history.direct_to_consumer'),
    img: '/history/history_2021_2022.jpeg',
    desc: t('history.direct_to_consumer_desc')
  },
  {
    color: 'orange', year: "2020", title: t('history.geographical_and_digital_expansion'),
    img: '/history/history_2020.jpeg',
    desc: t('history.geographical_and_digital_expansion_desc')
  },
  {
    color: 'violet', year: "2018", title: t('history.robotisation_and_expansion'),
    img: '/history/history_2016.jpeg',
    desc: t('history.robotisation_and_expansion_desc')
  },
  {
    color: 'yellow', year: "2015", title: t('history.service_development'),
    img: '/history/history_2015.jpeg',
    desc: t('history.service_development_desc')
  },
  {
    color: 'red', year: "2014", title: t('history.new_horizons'),
    img: '/history/history_2014.jpeg',
    desc: t('history.new_horizons_desc')
  },
  {
    color: 'cyan', year: "2013", title: t('history.fiesta_cube_and_dragonwar'),
    img: '/history/history_2013.jpg',
    desc: t('history.fiesta_cube_and_dragonwar_desc')
  },
  {
    color: 'green', year: "2012", title: t('history.board_games'),
    img: '/history/history_2012.jpeg',
    desc: t('history.board_games_desc')
  },
  {
    color: 'pink', year: "2010", title: t('history.moving'),
    img: '/history/history_2010.jpg',
    desc: t('history.moving_desc')
  },
  {
    color: 'amber', year: "2007", title: t('history.growth'),
    img: '/history/history_2007.jpg',
    desc: t('history.growth_desc')
  },
  {
    color: 'orange', year: "1998",
    title: t('history.foundation'),
    img: '/history/history_1998.jpg',
    desc: t('history.foundation_desc')
  }
])

const colorMap = {
  blue: { text: 'text-blue-600', border: 'border-blue-500' },
  orange: { text: 'text-orange-600', border: 'border-orange-500' },
  violet: { text: 'text-violet-600', border: 'border-violet-500' },
  yellow: { text: 'text-yellow-600', border: 'border-yellow-500' },
  red: { text: 'text-red-600', border: 'border-red-500' },
  cyan: { text: 'text-cyan-600', border: 'border-cyan-500' },
  green: { text: 'text-green-600', border: 'border-green-500' },
  pink: { text: 'text-pink-600', border: 'border-pink-500' },
  amber: { text: 'text-amber-600', border: 'border-amber-500' }
}

const getColors = (color) => colorMap[color] || colorMap['blue']

useHead({
  title: t('seo.seo_history_title'),
  link: [{ rel: 'canonical', href: ogUrl.value }],
  meta: [
    {
      property: 'og:title',
      content: t('seo.seo_history_title'),
    },
    {
      property: 'og:description',
      content: t('seo.seo_history_description'),
    },
    {
      property: 'og:url',
      content: ogUrl.value,
    },
    {
      name: 'description',
      content: t('seo.seo_history_description'),
    },
    {
      property: "og:type",
      content: "website"
    },
    {
      property: "og:image",
      content: ""
    },
    {
      property: "og:site_name",
      content: "CLD Distribution"
    },

  ],
});
</script>





  